import { render, staticRenderFns } from "./dialogMeal.vue?vue&type=template&id=2feb5773&scoped=true"
import script from "./dialogMeal.vue?vue&type=script&lang=js"
export * from "./dialogMeal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2feb5773",
  null
  
)

export default component.exports